import React, { useContext } from 'react'
import { useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'
import { Box, Text } from '@node-space/ui-components'
import CopyUrl from 'components/CopyUrl'
import { SheetStatusCard } from 'components/SheetStatusCard/SheetStatusCard'
import { contactAtom } from 'pages/Contacts/atoms/contactAtoms'
import { WalletActionContext } from 'pages/Wallets/context/WalletSheetProvider'
import { paymentLinkUrlAtom } from './atoms/atoms'

export const PaymentLinkComplete = () => {
  const { t } = useTranslation()
  const [walletAction] = useContext(WalletActionContext)
  const paymentLinkUrl = useAtomValue(paymentLinkUrlAtom)
  const contact = useAtomValue(contactAtom)

  return (
    <SheetStatusCard
      testid="payment-link-complete"
      headline={t('payments.paymentLinks.paymentRequestCreated')}
      borderless
      status="success"
      cardButton={{
        onClick: () => {
          walletAction?.onClose()
          walletAction?.meta?.onPaymentLinkSuccess?.()
        },
        name: t('payments.paymentLinks.backToPayments'),
        testid: 'back-to-payments',
      }}
    >
      <Box className="text-center" flexCol width="full" gapY={16}>
        <Box paddingX={12} borderRadius={8} background="subtle" className="py-[10px]">
          <CopyUrl isSheet={true} redirectUrl={paymentLinkUrl} testid="copy-channel-url" />
        </Box>
        <Text variant="caption-text">
          {t('payments.paymentLinks.paymentLinkCompleteDescription', {
            contactName: contact?.name,
          })}
        </Text>
      </Box>
    </SheetStatusCard>
  )
}
